import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { toastActionStyles } from './styles/toast-action.styles';
import type { ToastActionPropsInterface } from './types/toast-action.types';

export const ToastAction = forwardRef<HTMLDivElement, ToastActionPropsInterface>(
  (props: ToastActionPropsInterface, forwardedRef) => {
    const { children, className, css: cssProp, ...rest } = props;

    const styles = css(toastActionStyles, cssProp);

    return (
      <div
        className={cx('c11n', 'c11n_toast__action', styles, className)}
        data-c11n-component="Toast.Action"
        data-c11n-version={__C11N_VERSION__}
        ref={forwardedRef}
        {...rest}
      >
        {children}
      </div>
    );
  },
);

ToastAction.displayName = 'Toast.Action';
